import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-green-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a 
            href="https://www.v-shesh.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 rounded-lg"
            aria-label="v-shesh homepage"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_iwd-showcase/artifacts/sgnzua8f_v-shesh%20logo.png" 
              alt="v-shesh logo" 
              className="h-10 md:h-12 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" aria-label="Main navigation">
            <button
              onClick={() => scrollToSection('events')}
              className="text-gray-700 hover:text-green-800 font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 rounded px-2 py-1"
            >
              Events
            </button>
            <button
              onClick={() => scrollToSection('why-it-works')}
              className="text-gray-700 hover:text-green-800 font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 rounded px-2 py-1"
            >
              Why It Works
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-green-800 font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 rounded px-2 py-1"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-green-800 font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 rounded px-2 py-1"
            >
              Contact
            </button>
            <Button
              onClick={() => scrollToSection('enquiry')}
              className="bg-green-800 hover:bg-green-900 text-white px-6 py-2 font-semibold shadow-md hover:shadow-lg transition-all"
            >
              Enquire Now
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-gray-700 hover:text-green-800 focus:outline-none focus:ring-2 focus:ring-green-500 rounded-lg"
            aria-expanded={isMenuOpen}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-4 border-t border-green-200" aria-label="Mobile navigation">
            <div className="flex flex-col gap-3">
              <button
                onClick={() => scrollToSection('events')}
                className="text-left text-gray-700 hover:text-green-800 font-medium py-2 px-2 rounded hover:bg-green-50 transition-colors focus:outline-none focus:ring-2 focus:ring-green-500"
              >
                Events
              </button>
              <button
                onClick={() => scrollToSection('why-it-works')}
                className="text-left text-gray-700 hover:text-green-800 font-medium py-2 px-2 rounded hover:bg-green-50 transition-colors focus:outline-none focus:ring-2 focus:ring-green-500"
              >
                Why It Works
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="text-left text-gray-700 hover:text-green-800 font-medium py-2 px-2 rounded hover:bg-green-50 transition-colors focus:outline-none focus:ring-2 focus:ring-green-500"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-left text-gray-700 hover:text-green-800 font-medium py-2 px-2 rounded hover:bg-green-50 transition-colors focus:outline-none focus:ring-2 focus:ring-green-500"
              >
                Contact
              </button>
              <Button
                onClick={() => scrollToSection('enquiry')}
                className="bg-green-800 hover:bg-green-900 text-white w-full mt-2 font-semibold"
              >
                Enquire Now
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
